import { Company, Link } from '../../types';

export const companies: Company[] = [
  {
    id: 'synthesia',
    name: 'Synthesia',
    url: 'synthesia',
  },
  {
    id: 'phaidra',
    name: 'Phaidra.AI',
    url: 'phaidra',
  },
  {
    id: 'google-health',
    name: 'Google Health',
    url: 'google-health',
  },
  {
    id: 'deepmind',
    name: 'DeepMind',
    url: 'deepmind',
  },
  {
    id: 'channel4',
    name: 'Channel 4',
    url: 'channel4',
  },
  {
    id: 'nokia',
    name: 'Nokia',
    url: 'nokia',
  },
  {
    id: 'symbian',
    name: 'Symbian',
    url: 'symbian',
  },
  {
    id: 'bmg',
    name: 'Bertelsmann Media Group',
    url: 'bmg',
  },
];

export const links: Link[] = [
  {
    id: 'about-me',
    text: 'About me',
    url: '/about.html',
    bullet: '☆',
    newTab: false,
  },
  {
    id: 'download-cv',
    text: 'Résumé',
    url: '/resources/john-paul-holt.pdf',
    bullet: '▽',
    newTab: true,
  },
  {
    id: 'view-artwork',
    text: 'Artwork',
    url: 'https://dribbble.com/vanillabeach',
    bullet: '☆',
    newTab: true,
    hideOnMobile: true,
  },
  {
    id: 'linkedin',
    text: 'LinkedIn',
    url: 'https://www.linkedin.com/in/jpholt/',
    bullet: '☆',
    newTab: true,
  },
  {
    id: 'contact',
    text: 'E-Mail',
    url: 'mailto:john@jpholt.dev',
    bullet: '☆',
    newTab: false,
  },
];
